import {
  ActivateCreditMonitoringInput,
  ActivateCreditMonitoringResult,
  Mutation,
} from '@varo/graphql-schema-types';
import ActivateCreditMonitoringMutation from 'services/graphql/mutations/ActivateCreditMonitoring';
import { useMutation } from 'urql';

interface SubmitCreditScoreApplicationResult {
  submitCreditScoreApplication: (
    agreementId: ActivateCreditMonitoringInput,
  ) => Promise<ActivateCreditMonitoringResult | Error>;
  submitApplicationResult: {
    data?: ActivateCreditMonitoringResult;
    error?: Error;
    fetching: boolean;
  };
}

export const useActivateCreditMonitoring =
  (): SubmitCreditScoreApplicationResult => {
    const [{ data, error, fetching }, executeMutation] = useMutation<Mutation>(
      ActivateCreditMonitoringMutation,
    );

    const submitCreditScoreApplication = async (
      agreementIds: ActivateCreditMonitoringInput,
    ): Promise<ActivateCreditMonitoringResult | Error> => {
      try {
        const result = await executeMutation({
          input: agreementIds,
        });
        if (result.error) {
          throw result.error;
        }
        return result.data
          ?.activateCreditMonitoring as ActivateCreditMonitoringResult;
      } catch (error) {
        return error as Error;
      }
    };

    return {
      submitCreditScoreApplication,
      submitApplicationResult: {
        data: data?.activateCreditMonitoring,
        error,
        fetching,
      },
    };
  };
